<script>
  import { onMount, onDestroy } from "svelte";
  import { getWebsite } from "../helper/GetHelper";
  import DesignEdit from "./Website/Design_Edit.svelte";
  import SEOEdit from "./Website/SEO_Edit.svelte";
  import { templateDemo } from "../helper/TextGenerator";
  import { getDownloadURL } from "../helper/ImageCache";

  import { Image } from "../components/display";

  export let currentRoute;

  let model = null;
  let dbData = null;
  let navIndex = 0;
  let template = null;
  let interval;
  let editData = {
    modelKey: null,
    comp: null
  };
  onMount(async () => {
    dbData = await getWebsite(
      currentRoute.namedParams.id,
      currentRoute.namedParams.websiteId
    );
    model = dbData.data;
    console.log(model);
    // model.config.design.logoExternal = await getDownloadURL(model.config.design.logo);
    // template = `{% layout hero, ${JSON.stringify(model.config)} %}`;
    //generate();
    interval = setInterval(function() {
      generate();
    }, 20000);
  });
  const action = function(action) {
    editData = null;
    switch (action) {
      case "design":
        editData = { modelKey: "design", comp: DesignEdit };
        break;
      case "seo":
        editData = { modelKey: "seo", comp: SEOEdit };
        break;
    }
    if (editData != null) navIndex = 1;
  };

  let templateRender = null;
  const generate = async function() {
    model.config.design.logoExternal = await getDownloadURL(
      model.config.design.logo
    );

    template = `{% layout hero, ${JSON.stringify(model.config)} %}`;

    templateRender = await templateDemo(
      template,
      model.config.design.pageStyle
    );
  };
  onDestroy(() => {
    interval();
  });
</script>

{currentRoute.namedParams.id} {currentRoute.namedParams.websiteId}
<div class="fixed top-0 left-0 w-screen h-screen">
  <div class="h-screen flex overflow-hidden bg-gray-100">
    <!-- Static sidebar for desktop -->
    <div class="hidden md:flex md:flex-shrink-0">
      <div class="flex flex-col w-80 bg-gray-800 text-white">
        <div class="h-0 flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
          <div class="flex items-center flex-shrink-0 px-4">
            <img
              class="h-8 w-auto"
              src="/img/logos/workflow-logo-on-dark.svg"
              alt="Workflow" />
          </div>
          <!-- Sidebar component, swap this element with another sidebar if you like -->
          {#if navIndex == 0}
            <nav class="mt-5 px-2">
              <div
                on:click={() => {
                  action('design');
                }}
                class="group flex items-center px-2 py-2 text-base leading-6
                font-medium rounded-md text-white bg-gray-900 focus:outline-none
                focus:bg-gray-700 transition ease-in-out duration-150">
                <svg
                  class="mr-4 h-6 w-6 text-gray-300 group-hover:text-gray-300
                  group-focus:text-gray-300 transition ease-in-out duration-150"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0
                    011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10M9 21h6" />
                </svg>
                Design
              </div>
              <div
                on:click={() => {
                  action('seo');
                }}
                class="group flex items-center px-2 py-2 text-base leading-6
                font-medium rounded-md text-white bg-gray-900 focus:outline-none
                focus:bg-gray-700 transition ease-in-out duration-150">
                <svg
                  class="mr-4 h-6 w-6 text-gray-300 group-hover:text-gray-300
                  group-focus:text-gray-300 transition ease-in-out duration-150"
                  stroke="currentColor"
                  fill="none"
                  viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1 1 0
                    011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10M9 21h6" />
                </svg>
                SEO
              </div>
              {#if model != null}
                {#each model.sections as section}
                  <div
                    on:click={() => {
                      action(section);
                    }}
                    class="group flex items-center px-2 py-2 text-base leading-6
                    font-medium rounded-md text-white bg-gray-900
                    focus:outline-none focus:bg-gray-700 transition ease-in-out
                    duration-150">
                    <svg
                      class="mr-4 h-6 w-6 text-gray-300
                      group-hover:text-gray-300 group-focus:text-gray-300
                      transition ease-in-out duration-150"
                      stroke="currentColor"
                      fill="none"
                      viewBox="0 0 24 24">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M3 12l9-9 9 9M5 10v10a1 1 0 001 1h3a1 1 0 001-1v-4a1
                        1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1h3a1 1 0 001-1V10M9
                        21h6" />
                    </svg>
                    {section.type}
                    <br />
                    {section.data}
                  </div>
                {/each}
              {/if}
            </nav>
          {:else if navIndex == 1}
            <div class="px-4">
              <div
                on:click={() => {
                  navIndex = 0;
                }}>
                BACK
              </div>
              <div>
                <svelte:component
                  this={editData.comp}
                  bind:model={model.config[editData.modelKey]} />
              </div>
            </div>
          {/if}

        </div>
        <div class="flex-shrink-0 flex bg-gray-700 p-4">
          <a href="#" class="flex-shrink-0 w-full group block">
            <div class="flex items-center">
              <div>
                <img
                  class="inline-block h-9 w-9 rounded-full"
                  src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                  alt="" />
              </div>
              <div class="ml-3">
                <p class="text-sm leading-5 font-medium text-white">Tom Cook</p>
                <p
                  class="text-xs leading-4 font-medium text-gray-300
                  group-hover:text-gray-200 transition ease-in-out duration-150">
                  View profile
                </p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="flex flex-col w-0 flex-1 overflow-hidden">
      <div class="md:hidden pl-1 pt-1 sm:pl-3 sm:pt-3">
        <button
          class="-ml-0.5 -mt-0.5 h-12 w-12 inline-flex items-center
          justify-center rounded-md text-gray-500 hover:text-gray-900
          focus:outline-none focus:bg-gray-200 transition ease-in-out
          duration-150"
          aria-label="Open sidebar">
          <svg
            class="h-6 w-6"
            stroke="currentColor"
            fill="none"
            viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>
      <main
        class="flex-1 relative z-0 overflow-y-auto focus:outline-none"
        tabindex="0">
        {#if model != null}
          <div>
            {@html templateRender}
          </div>
        {/if}

      </main>
    </div>
  </div>
</div>
